const firstResourcesSection = {
  name: 'Vision, resources and impact',
  elements: [
  ]
}

export default firstResourcesSection
